<template>
  <v-sheet
    raised
    rounded
    :class="['pa-4', 'pa-sm-8', 'pt-sheet', !noHighlight && 'sheet-highlight']"
    v-bind:style="sheetStyles"
  >
    <div
      v-if="this.title || this.tooltip"
      class="d-flex justify-space-between header mb-4"
    >
      <div class="d-flex title">
        <h2 v-if="this.title" class="headline mr-8">{{ title }}</h2>
        <v-tooltip bottom v-if="this.tooltip" color="colorUiGrey90">
          <template v-slot:activator="{ on, attrs }">
            <v-icon left v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </div>
      <slot name="header" />
    </div>
    <v-divider class="mb-2" v-if="subtitle" />
    <div v-if="subtitle" class="subtitle-2 mb-4 colorNeutralsNavy400--text">
      {{ subtitle }}
    </div>
    <slot></slot>
  </v-sheet>
</template>

<script>
export default {
  name: "PtSheet",
  props: {
    highlight: {
      type: String,
      default: "colorPtRoyal25"
    },
    title: String,
    tooltip: String,
    subtitle: String,
    noHighlight: Boolean
  },
  computed: {
    sheetStyles() {
      let currentThemeElement = this.getCSSColor(this.highlight);
      return {
        "border-color": currentThemeElement
      };
    }
  },
  data: () => ({}),
  methods: {
    getCSSColor(color) {
      let currentThemeElement = this.$vuetify.theme.currentTheme[color];
      if (!currentThemeElement) currentThemeElement = color;
      return currentThemeElement;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-sheet.pt-sheet {
  // overrides default 4px from vuetify
  border-radius: 8px !important;
  box-shadow: 0 4px 10px 0 $dark-grey;

  &.sheet-highlight {
    border-top: 8px solid;
  }
}
.v-tooltip__content {
  max-width: 300px;
}
</style>
